// extracted by mini-css-extract-plugin
export const layout = "layout-module--layout--2Gt_Q";
export const mainContainer = "layout-module--mainContainer--1NdQk";